export const clinicInfo_LABELS = {
  clinicName: "Clinic Name",
  clinicAddress: "Clinic Address",
  bpSiteId: "BP Site ID",
  user: "Username",
  emailId: "Email Address",
  status: "Subscription Type - Status",
  totalLicenceKeys: "Total Licences",
  noOfUsersAdded: "GPs Assigned",
};
